import type { FC, ReactElement, ReactNode } from 'react';
import type { ViewProps } from 'react-native';
import { View, StyleSheet } from 'react-native';

/**
 * Stacks children on top of each other (like MUI Stack / CSS position relative+absolute).
 * The first child defines the size; all subsequent children are absolutely positioned to fill it.
 */
type StackProps = ViewProps & { children: ReactNode };
export const Stack: FC<StackProps> = ({ children, style, ...props }) => (
  <View style={[{ position: 'relative' }, style]} {...props}>
    {Array.isArray(children)
      ? children.map((child, i) =>
          i === 0 ? (
            (child as ReactElement)
          ) : (
            <View
              key={i}
              style={[StyleSheet.absoluteFill, { pointerEvents: 'box-none' }]}
            >
              {child}
            </View>
          )
        )
      : children}
  </View>
);
